import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../service/authentication.service';
import { ApiService } from '../../service/api.service';
import { UtilService } from '../../service/util.service';
import { Constants } from '../../constants/constants';
import { ToastService } from '../../service/toast.service';
import { Router } from '@angular/router';
import { SearchResultsComponent } from 'src/app/search-results/search-results.component';
import { SearchDataService } from 'src/app/service/search-data.service';

@Component({
  selector: 'app-dealer-home',
  templateUrl: './dealer-home.component.html',
  styleUrls: ['./dealer-home.component.scss']
})
export class DealerHomeComponent implements OnInit {

  isAdmin: boolean = false;
  isLoggedIn: boolean = false;
  accountCategory: string;
  accountStatus: string;
  tnc: any = {
    name: null,
    description: null,
    url: null,
    version: null,
    effectiveDate: null,
    id: null
  };
  showTnc: boolean = false;
  isTnCAccepted: boolean = false;
  isDeveloper: boolean = false;
  @ViewChild('searchResult') searchResult: SearchResultsComponent;
  searchedVehicleList: Array<any>;
  searchedLocationList: Array<any>;
  searchedServicePackageList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;

  constructor(public apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toast: ToastService, private router: Router, private searchService: SearchDataService) {
    this.authService.authenticationState.subscribe(state => {
      console.log("logged in user details : ", this.authService.loggedInUser);
      if (state) {
        this.isLoggedIn = true;
        //if(this.authService.isAdmin()) {
        //this.isAdmin = true;
        if (this.authService.isUserRoleAllowed()) {
          if (this.authService.isAdmin())
            this.isAdmin = true;
          // else if (this.authService.isDeveloper())
          //   this.isDeveloper = true;
          // // this.isAdmin = true;
        } else {
          this.toast.showError("You don't have the permission to access this portal.");
          this.authService.logout();
          this.router.navigate(["/"]);
        }
      } else {
        this.isLoggedIn = false;
      }
      console.log("isAdmin::", this.isAdmin)
    });
  }

  ngOnInit() {
    this.searchService.searchedData.subscribe(data => {
      this.processSearchResult();
    });

    this.accountCategory = this.apiService.accountDetail.category;
    this.accountStatus = this.apiService.accountDetail.status;

    // DONOT remove this code, when Tnc in Place we need this
    // if (this.accountStatus == Constants.INACTIVE || this.accountStatus == Constants.PENDING) {
    //   document.getElementById("openTnc").click();
    //   this.getTncForAccount();
    // }
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  getTncForAccount() {
    this.utilService.showSpinner();
    this.apiService.getTncForAccount().then((data) => {
      this.showTnc = true;
      this.utilService.hideSpinner();
      this.tnc = data;
      console.log("TnC data::", this.tnc);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getTncForAccount();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  acceptTnC(payload: any) {
    if (!this.isTnCAccepted) return;
    this.utilService.showSpinner();
    this.apiService.acceptTnC(payload).then((data) => {
      this.showTnc = false;
      this.apiService.accountDetail.status = Constants.ENABLED;
      this.utilService.hideSpinner();
      document.getElementById("closeTnc").click();
      console.log("TnC accept data::", data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.acceptTnC(payload);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toast.showError(error.error.message);
        else this.toast.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  acceptTnc() {
    this.utilService.showSpinner();
    this.apiService.getClientIpAddress().then((data) => {
      this.utilService.hideSpinner();
      console.log("IP Address::", data);
      if (data && data.query) {
        var payload = {
          "tncProfileId": this.tnc.id,
          "userIp": data.query
        }
        this.acceptTnC(payload);
      }
    }).catch((error) => {
      console.log("err : ", error);
      this.toast.showError(Constants.UNKNOWN_ERROR);
      this.utilService.hideSpinner();
    });
  }

  onNavSearchClick() {
    this.searchResult.onNavSearchClick();
  }

  private processSearchResult() {

    this.searchedVehicleList = this.searchService.getSearchedDataForType(Constants.VEHICLES);
    this.searchedLocationList = this.searchService.getSearchedDataForType(Constants.LOCATIONS);
    this.searchedServicePackageList = this.searchService.getSearchedDataForType(Constants.SERVICE_PACKAGE);
    this.selectedSearchItemForView = null;
    if ((this.searchedVehicleList && this.searchedVehicleList.length > 0) ||
      (this.searchedLocationList && this.searchedLocationList.length > 0) ||
      (this.searchedServicePackageList && this.searchedServicePackageList.length > 0)) {
      this.showSearchResult = true;
    }
    else {
      this.showSearchResult = false;
    }

  }

}